import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import sweetalert from "sweetalert";
import ApiAppVersions from "@/api/ApiAppVersions";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@/data/CKeditor/config";
import i18n from "@/i18n";
let CreateAppVersionUpdates = class CreateAppVersionUpdates extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.HasLoading = false;
        this.editorConfig = CKEditor.editorConfig(ApiEnter.CurrentSessionUUID);
        this.Breadcrumbs = [
            {
                to: "/",
                text: i18n.t("breadcrumbs.home"),
            },
            {
                to: "/secure/admin/app-version-updates",
                exact: true,
                text: i18n.t("app_version_updates.app_version_updates"),
            },
            {
                to: "/secure/admin/app-version-updates",
                text: i18n.t("app_version_updates.edit_app_version_updates"),
                disabled: true,
            },
        ];
        this.newData = {
            version: "",
            platform: null,
            is_mandatory: false,
            confirmation_required: false,
            release_notes: "",
            update_url: "",
            released_at: ""
        };
        this.releasedAtDateSelecting = false;
        this.CurrentVersionUUID = "";
    }
    canSubmit() {
        return (this.newData.version &&
            this.newData.platform &&
            this.newData.release_notes &&
            this.newData.update_url &&
            this.newData.released_at);
    }
    async OnClickSubmit() {
        // this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const success = await ApiAppVersions.UpdateAppVersionUpdate(ApiEnter.CurrentSessionUUID, this.CurrentVersionUUID, this.newData.version, this.newData.platform, this.newData.is_mandatory, this.newData.confirmation_required, this.newData.release_notes, this.newData.update_url, this.newData.released_at);
            if (!success) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/secure/admin/app-version-updates`);
            });
        }
        this.HasLoading = false;
    }
    async GetAppVersionInfo() {
        const response = await ApiAppVersions.GetAppVersionByUUID(ApiEnter.CurrentSessionUUID, this.CurrentVersionUUID);
        this.newData.version = response.version;
        this.newData.is_mandatory = !!response.is_mandatory;
        this.newData.confirmation_required = !!response.confirmation_required;
        this.newData.update_url = response.update_url;
        this.newData.platform = response.platform;
        this.newData.release_notes = response.release_notes;
        this.newData.released_at = response.released_at;
    }
    created() {
        this.CurrentVersionUUID = this.$route.params.uuid;
        this.GetAppVersionInfo();
    }
};
CreateAppVersionUpdates = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], CreateAppVersionUpdates);
export default CreateAppVersionUpdates;
